// The shared LangMagic app switcher (<langmagic-switcher>, loaded from coach's lm-nav/v1.js in the
// HTML shells). Source and docs live in the coach repo: public/lm-nav/{v1.js,README.md}.
export const APP_SWITCHER_APP = 'meet';
// The UI is English-only; the switcher knows en and ru
export const APP_SWITCHER_LANG = 'en';
// The element's click area is never smaller than this, with 2px padding around the icon
export const APP_SWITCHER_MIN_HIT = 44;
export const APP_SWITCHER_PADDING = 2;
